import { cn } from "@/lib/utils"

// Steel & Ember — shimmer loader.
// Use as <Skeleton className="h-4 w-24" /> for inline placeholders.
function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-md bg-[color:var(--surface-elevated,#27272A)]",
        "before:absolute before:inset-0 before:-translate-x-full before:animate-shimmer before:bg-gradient-to-r before:from-transparent before:via-white/8 before:to-transparent dark:before:via-white/6",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton }
